import { render, staticRenderFns } from "./NotificationIcon.vue?vue&type=template&id=664607b6&scoped=true&"
import script from "./NotificationIcon.vue?vue&type=script&lang=js&"
export * from "./NotificationIcon.vue?vue&type=script&lang=js&"
import style0 from "./NotificationIcon.vue?vue&type=style&index=0&id=664607b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "664607b6",
  null
  
)

export default component.exports